/* The Live Free Files · interactive components (BUILD BRIEF, 22 Sep 2026).
   One runtime, loaded once by the article body section, scanning for [data-lf-component].

   THE RULES THIS FILE ENFORCES, because they are the point of the library:
     · Nothing a reader answers ever leaves this page. No fetch of answers, no analytics,
       no Klaviyo, no server. The only network call in here is a public product price.
     · Nothing scores the reader. No totals out of ten, no "your skin is a 7".
     · No streaks, no guilt, no comparison to other readers.
     · Wrong is never "wrong". It is the mechanism, in a sentence.
     · Progressive enhancement: every component either wraps content that is already in the
       article, or adds a step in front of a number the prose already states. Script off,
       the article is complete. Never move unique content into a config block.

   Authoring (this is the interface a writer uses, no JavaScript):
     <div data-lf-component="guess">
       <script type="application/json">{ "question": "...", "answer": 11 }</script>
     </div>
   The config is optional for components that read the markup they wrap. */
(function () {
  'use strict';
  if (window.__lfFC) { window.__lfFC.scan(); return; }
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var store = {
    get: function (k) { try { return localStorage.getItem('lf_fc_' + k); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem('lf_fc_' + k, v); } catch (e) {} }
  };
  function el(tag, cls, text) { var n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; }
  function cfg(root) {
    var s = root.querySelector('script[type="application/json"]');
    if (!s) return {};
    try { return JSON.parse(s.textContent) || {}; } catch (e) { return {}; }
  }
  function fmt(n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  /* one live region per component, so a screen reader hears the feedback */
  function live(parent) { var n = el('p', 'lf-fc__live'); n.setAttribute('role', 'status'); n.setAttribute('aria-live', 'polite'); parent.appendChild(n); return n; }

  var C = {};

  /* ── 1 · Guess First ─────────────────────────────────────────────────────────
     Commit to a number, then see the real one. Being wrong is the teaching moment.
     The number is always already in the prose, so script-off loses nothing. */
  C.guess = function (root, c) {
    if (c.answer == null) return;
    var box = el('div', 'lf-fc lf-fc--guess');
    var min = c.min != null ? c.min : 0;
    var max = c.max != null ? c.max : Math.max(Math.ceil(c.answer * 2.5), min + 10);
    var start = c.start != null ? c.start : Math.round((min + max) / 2);
    box.appendChild(el('p', 'lf-fc__kicker', c.kicker || 'guess first'));
    var q = el('h3', 'lf-fc__q', c.question || ''); box.appendChild(q);
    var id = 'lf-guess-' + Math.random().toString(36).slice(2, 7);
    var lab = el('label', 'lf-sr', c.question || 'Your guess'); lab.htmlFor = id; box.appendChild(lab);
    var row = el('div', 'lf-fc__sliderrow');
    var input = el('input', 'lf-fc__slider'); input.type = 'range'; input.id = id;
    input.min = min; input.max = max; input.step = c.step || 1; input.value = start;
    var out = el('output', 'lf-fc__out'); out.htmlFor = id;
    var unit = c.unit || '';
    var show = function () { out.textContent = (c.prefix || '') + fmt(input.value) + (unit ? ' ' + unit : ''); };
    show(); input.addEventListener('input', show);
    row.appendChild(input); row.appendChild(out); box.appendChild(row);
    var btn = el('button', 'lf-fc__btn', c.submit || 'lock it in'); btn.type = 'button';
    box.appendChild(btn);
    var reveal = el('div', 'lf-fc__reveal'); reveal.hidden = true; box.appendChild(reveal);
    var msg = live(box);
    btn.addEventListener('click', function () {
      if (!reveal.hidden) return;
      var g = Number(input.value), a = Number(c.answer), off = Math.abs(a - g);
      input.disabled = true; btn.hidden = true;
      reveal.appendChild(el('p', 'lf-fc__big', (c.prefix || '') + fmt(c.answer) + (unit ? ' ' + unit : '')));
      /* never "wrong": name the gap, then explain */
      var line = off === 0 ? (c.exact || 'Exactly right.')
        : (c.compare || 'You guessed {guess}. The number is {answer}.').replace('{guess}', (c.prefix || '') + fmt(g) + (unit ? ' ' + unit : '')).replace('{answer}', (c.prefix || '') + fmt(a) + (unit ? ' ' + unit : ''));
      reveal.appendChild(el('p', 'lf-fc__because', line));
      if (c.because) reveal.appendChild(el('p', 'lf-fc__body', c.because));
      reveal.hidden = false;
      if (!reduce) { reveal.classList.add('is-in'); }
      msg.textContent = line + (c.because ? ' ' + c.because : '');
    });
    root.appendChild(box);
  };

  /* ── 2 · Myth busting ───────────────────────────────────────────────────────
     Reads the statements already written in the article. On a myth-busting piece every
     statement is false, so this is NOT a true/false quiz: asking "fact or myth?" when the
     answer is always myth teaches pattern-matching, not the mechanism. Instead the reader
     says whether they believed it, which is a real commitment with nothing to lose, and the
     mechanism lands as the correction. Set "mixed": true for a deck that genuinely contains
     both, and mark those items with "fact": true. */
  C.myth = function (root, c) {
    var sel = c.selector || 'h2';
    var scope = (c.scope && document.querySelector(c.scope)) || root.closest('.lff, .lf-fbody__prose') || document;
    var heads = Array.prototype.slice.call(scope.querySelectorAll(sel)).filter(function (h) {
      return /^\s*\d+\s*[.)]/.test(h.textContent);           /* "1. ..." numbered statements */
    });
    if (!heads.length) return;
    var items = heads.map(function (h, i) {
      var body = [], n = h.nextElementSibling;
      while (n && n.tagName !== h.tagName && !/^H[12]$/.test(n.tagName)) { if (n.tagName === 'P') body.push(n.innerHTML); n = n.nextElementSibling; }
      var over = (c.items || [])[i] || {};
      return {
        text: h.textContent.replace(/^\s*\d+\s*[.)]\s*/, '').replace(/^[\u201C"]|[\u201D"]$/g, ''),
        fact: over.fact === true,
        why: over.why || body.slice(0, 1).join('')
      };
    });
    var mixed = c.mixed === true || items.some(function (it) { return it.fact; });
    var box = el('div', 'lf-fc lf-fc--myth');
    box.appendChild(el('p', 'lf-fc__kicker', c.kicker || (mixed ? 'myth or fact' : 'myth busting')));
    var counter = el('p', 'lf-fc__count'); box.appendChild(counter);
    var card = el('div', 'lf-fc__card'); box.appendChild(card);
    var msg = live(box);
    var i = 0;
    function render() {
      card.innerHTML = '';
      counter.textContent = (c.counter || 'myth {n} of {total}').replace('{n}', i + 1).replace('{total}', items.length);
      card.appendChild(el('p', 'lf-fc__statement', '\u201C' + items[i].text + '\u201D'));
      var row = el('div', 'lf-fc__row');
      var choices = mixed
        ? [[true, c.factLabel || 'fact'], [false, c.mythLabel || 'myth']]
        : [[true, c.believedLabel || 'I believed this'], [false, c.notLabel || 'never bought it']];
      choices.forEach(function (pair) {
        var b = el('button', 'lf-fc__btn lf-fc__btn--choice', pair[1]); b.type = 'button';
        b.addEventListener('click', function () { answer(pair[0]); });
        row.appendChild(b);
      });
      card.appendChild(row);
    }
    function answer(said) {
      var it = items[i];
      card.querySelectorAll('button').forEach(function (b) { b.disabled = true; });
      var res = el('div', 'lf-fc__reveal is-in');
      /* busting mode has no right answer: the verdict is about the claim, never the reader */
      var line = mixed
        ? (said === it.fact ? (c.right || 'Right. It is a ' + (it.fact ? 'fact' : 'myth') + '.') : (c.wrong || 'It is a ' + (it.fact ? 'fact' : 'myth') + '.'))
        : (c.bust || 'It is a myth. Here is what is actually happening.');
      res.appendChild(el('p', 'lf-fc__verdictline' + (mixed && said === it.fact ? ' is-right' : ''), line));
      if (it.why) { var p = el('p', 'lf-fc__body'); p.innerHTML = it.why; res.appendChild(p); }
      var nav = el('div', 'lf-fc__row');
      if (i < items.length - 1) {
        var next = el('button', 'lf-fc__btn', c.next || 'next'); next.type = 'button';
        next.addEventListener('click', function () { i++; render(); card.querySelector('button').focus(); });
        nav.appendChild(next);
      } else if (c.end) {
        nav.appendChild(el('p', 'lf-fc__body', c.end));
      }
      res.appendChild(nav);
      card.appendChild(res);
      msg.textContent = res.textContent;
    }
    render();
    root.appendChild(box);
  };

  /* ── 3 · What Would You Rule ─────────────────────────────────────────────────
     The reader commits to a tier before the File's verdict is revealed.
     The verdict stays in the HTML for search; this only collapses it visually, on a
     first visit, and there is always a one-tap way to skip straight to it. */
  var TIERS = [
    ['worth-it', 'Worth it'], ['worth-it-later', 'Worth it, later'], ['depends-on', 'Depends on'],
    ['save-your-money', 'Save your money'], ['doesnt-hold-up', "Doesn't hold up"], ['hard-no', 'Hard no']
  ];
  C.rule = function (root, c) {
    var tier = c.tier || (root.dataset.lfTier || '');
    if (!tier) return;
    var target = document.querySelector(c.verdict || '.lf-fvbox, .lff .verdict');
    var key = 'ruled_' + (c.id || location.pathname);
    var already = store.get(key);
    var box = el('div', 'lf-fc lf-fc--rule');
    box.appendChild(el('p', 'lf-fc__kicker', c.kicker || 'before you read the ruling'));
    box.appendChild(el('h3', 'lf-fc__q', c.question || 'What would you rule?'));
    if (c.context) box.appendChild(el('p', 'lf-fc__body', c.context));
    var grid = el('div', 'lf-fc__tiers');
    var msg = live(box);
    function finish(picked) {
      store.set(key, picked || tier);
      grid.querySelectorAll('button').forEach(function (b) {
        b.disabled = true;
        if (b.dataset.tier === tier) b.classList.add('is-answer');
        if (picked && b.dataset.tier === picked && picked !== tier) b.classList.add('is-yours');
      });
      if (target) { target.classList.remove('lf-fc-hidden'); if (!reduce) target.classList.add('lf-fc-in'); }
      var res = el('div', 'lf-fc__reveal is-in');
      var name = (TIERS.filter(function (t) { return t[0] === tier; })[0] || [, tier])[1];
      if (!picked) res.appendChild(el('p', 'lf-fc__verdictline', (c.skipped || 'The ruling is {tier}.').replace('{tier}', name)));
      else if (picked === tier) res.appendChild(el('p', 'lf-fc__verdictline is-right', (c.agreed || 'Same ruling: {tier}.').replace('{tier}', name)));
      else res.appendChild(el('p', 'lf-fc__verdictline', (c.differed || 'We ruled {tier}. The reasoning is below, and disagreeing with it is allowed.').replace('{tier}', name)));
      if (c.because) res.appendChild(el('p', 'lf-fc__body', c.because));
      box.appendChild(res);
      msg.textContent = res.textContent;
      if (target && c.scroll !== false) setTimeout(function () { target.scrollIntoView({ block: 'nearest', behavior: reduce ? 'auto' : 'smooth' }); }, 60);
    }
    TIERS.forEach(function (t) {
      var b = el('button', 'lf-fc__btn lf-fc__btn--tier lf-fc__btn--' + t[0], t[1]);
      b.type = 'button'; b.dataset.tier = t[0];
      b.addEventListener('click', function () { finish(t[0]); });
      grid.appendChild(b);
    });
    box.appendChild(grid);
    var skip = el('button', 'lf-fc__skip', c.skip || 'just show me the ruling'); skip.type = 'button';
    skip.addEventListener('click', function () { finish(null); });
    box.appendChild(skip);
    root.appendChild(box);
    /* hide the verdict only for a first-time reader, and only once the script is running */
    if (target && !already) target.classList.add('lf-fc-hidden');
  };

  /* ── 4 · The Label Decoder ───────────────────────────────────────────────────
     Marks the first five, the 1% line, and anything flagged, on a hand-picked list or
     one the reader pastes in. All matching is local; nothing is uploaded. */
  C.label = function (root, c) {
    var flags = c.flags || {};
    var box = el('div', 'lf-fc lf-fc--label');
    box.appendChild(el('p', 'lf-fc__kicker', c.kicker || 'read the label'));
    box.appendChild(el('h3', 'lf-fc__q', c.question || 'Three moves, on a real label.'));
    var picks = el('div', 'lf-fc__row lf-fc__row--wrap');
    var id = 'lf-label-' + Math.random().toString(36).slice(2, 7);
    var lab = el('label', 'lf-sr', c.inputLabel || 'Paste an ingredient list'); lab.htmlFor = id;
    var ta = el('textarea', 'lf-fc__textarea'); ta.id = id; ta.rows = 3; ta.placeholder = c.placeholder || 'or paste any ingredient list here';
    var out = el('div', 'lf-fc__labelout');
    var msg = live(box);
    function decode(text) {
      out.innerHTML = '';
      var parts = text.split(/[,;]|•/).map(function (s) { return s.replace(/\.$/, '').trim(); }).filter(Boolean);
      if (parts.length < 2) { out.appendChild(el('p', 'lf-fc__body', c.unparsed || 'That does not look like an ingredient list yet. They are separated by commas.')); msg.textContent = out.textContent; return; }
      var onePct = -1;
      for (var j = 0; j < parts.length; j++) {
        if (/^(phenoxyethanol|tocopherol|sodium benzoate|potassium sorbate|citric acid|xanthan gum|ethylhexylglycerin|disodium edta|benzyl alcohol)\b/i.test(parts[j])) { onePct = j; break; }
      }
      var list = el('ol', 'lf-fc__ings');
      parts.forEach(function (p, j) {
        var li = el('li', 'lf-fc__ing');
        if (j < 5) li.classList.add('is-first5');
        if (onePct > -1 && j >= onePct) li.classList.add('is-trace');
        li.appendChild(el('span', 'lf-fc__ing-n', p));
        var key = Object.keys(flags).filter(function (k) { return p.toLowerCase().indexOf(k.toLowerCase()) > -1; })[0];
        if (key) { li.classList.add('is-flagged'); li.appendChild(el('span', 'lf-fc__ing-flag', flags[key])); }
        else if (j < 5) li.appendChild(el('span', 'lf-fc__ing-note', c.first5Note || 'does most of the work'));
        else if (onePct > -1 && j >= onePct) li.appendChild(el('span', 'lf-fc__ing-note', c.traceNote || 'below the 1% line'));
        list.appendChild(li);
      });
      out.appendChild(list);
      var sum = [];
      sum.push((c.first5 || 'The first five are most of the bottle.'));
      sum.push(onePct > -1 ? (c.onePct || 'Everything from the preservative down is roughly 1% or less, in any order the brand likes.') : (c.noOnePct || 'No obvious 1% marker here, so read the order as written.'));
      out.appendChild(el('p', 'lf-fc__body', sum.join(' ')));
      msg.textContent = out.textContent;
    }
    (c.examples || []).forEach(function (ex, j) {
      var b = el('button', 'lf-fc__btn lf-fc__btn--choice', ex.name); b.type = 'button';
      b.addEventListener('click', function () { ta.value = ex.list; decode(ex.list); });
      picks.appendChild(b);
      if (j === 0) setTimeout(function () { ta.value = ex.list; decode(ex.list); }, 0);
    });
    box.appendChild(picks); box.appendChild(lab); box.appendChild(ta);
    var go = el('button', 'lf-fc__btn', c.submit || 'decode it'); go.type = 'button';
    go.addEventListener('click', function () { decode(ta.value); });
    box.appendChild(go); box.appendChild(out);
    root.appendChild(box);
  };

  /* ── 5 · The Cost Calculator ─────────────────────────────────────────────────
     Prices come from Shopify at read time, never hardcoded. The total goes DOWN,
     which is the honest direction for this one. */
  C.cost = function (root, c) {
    var steps = c.steps || []; if (!steps.length) return;
    var box = el('div', 'lf-fc lf-fc--cost');
    box.appendChild(el('p', 'lf-fc__kicker', c.kicker || 'what it actually costs'));
    box.appendChild(el('h3', 'lf-fc__q', c.question || 'Build a routine and watch the number.'));
    var chosen = {};
    var totalEl = el('p', 'lf-fc__big');
    var vs = el('p', 'lf-fc__because');
    var msg = live(box);
    function paint() {
      var t = 0; steps.forEach(function (s, i) { var o = s.options[chosen[i]]; t += (o && o.price) || 0; });
      totalEl.textContent = (c.currency || '$') + t.toFixed(2).replace(/\.00$/, '') + (c.per || ' a month');
      if (c.compare) {
        var d = c.compare - t;
        vs.textContent = d > 0 ? (c.less || '{n} less than the {compare} the average routine costs.').replace('{n}', (c.currency || '$') + d.toFixed(2).replace(/\.00$/, '')).replace('{compare}', (c.currency || '$') + c.compare)
          : (c.more || 'About the same as the average routine.');
      }
      msg.textContent = totalEl.textContent + ' ' + vs.textContent;
    }
    steps.forEach(function (s, i) {
      chosen[i] = 0;
      var row = el('div', 'lf-fc__coststep');
      row.appendChild(el('p', 'lf-fc__steplabel', s.label));
      var opts = el('div', 'lf-fc__row lf-fc__row--wrap');
      s.options.forEach(function (o, j) {
        var b = el('button', 'lf-fc__btn lf-fc__btn--choice' + (j === 0 ? ' is-on' : ''), o.name); b.type = 'button';
        b.setAttribute('aria-pressed', String(j === 0));
        b.addEventListener('click', function () {
          chosen[i] = j;
          opts.querySelectorAll('button').forEach(function (x, k) { x.classList.toggle('is-on', k === j); x.setAttribute('aria-pressed', String(k === j)); });
          paint();
        });
        opts.appendChild(b);
        /* live price, when the option names a product */
        if (o.handle && o.price == null) {
          fetch('/products/' + o.handle + '.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (p) { o.price = (p.price || 0) / 100; b.textContent = o.name + ' · ' + (c.currency || '$') + o.price.toFixed(2).replace(/\.00$/, ''); paint(); })
            .catch(function () {});
        } else if (o.price != null) { b.textContent = o.name + ' · ' + (c.currency || '$') + Number(o.price).toFixed(2).replace(/\.00$/, ''); }
      });
      row.appendChild(opts); box.appendChild(row);
    });
    box.appendChild(totalEl); if (c.compare) box.appendChild(vs);
    paint();
    root.appendChild(box);
  };

  /* ── 6 · The Selector ────────────────────────────────────────────────────────
     Pick a value, the panels below switch. The panels are real markup in the article,
     so with the script off they are simply all visible, which reads as a normal list. */
  C.selector = function (root, c) {
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-lf-when]'));
    if (!panels.length) return;
    var values = [];
    panels.forEach(function (p) { var v = p.getAttribute('data-lf-when'); if (values.indexOf(v) === -1) values.push(v); });
    var box = el('div', 'lf-fc lf-fc--selector');
    if (c.kicker) box.appendChild(el('p', 'lf-fc__kicker', c.kicker));
    if (c.question) box.appendChild(el('h3', 'lf-fc__q', c.question));
    var row = el('div', 'lf-fc__row lf-fc__row--wrap');
    var msg = live(box);
    function pick(v) {
      panels.forEach(function (p) { p.hidden = p.getAttribute('data-lf-when') !== v; });
      row.querySelectorAll('button').forEach(function (b) { var on = b.dataset.v === v; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', String(on)); });
      var shown = panels.filter(function (p) { return !p.hidden; })[0];
      msg.textContent = (c.announce || 'Showing {v}.').replace('{v}', (c.labels || {})[v] || v);
      if (shown) shown.setAttribute('tabindex', '-1');
    }
    values.forEach(function (v) {
      var b = el('button', 'lf-fc__btn lf-fc__btn--choice', (c.labels || {})[v] || v); b.type = 'button'; b.dataset.v = v;
      b.addEventListener('click', function () { pick(v); });
      row.appendChild(b);
    });
    box.appendChild(row);
    root.insertBefore(box, root.firstChild);
    pick(c.start || values[0]);
  };

  /* ── 7 · The Quiz ────────────────────────────────────────────────────────────
     N questions, N options, one outcome. No score, no ranking: the outcome is a
     description and a next step, never a grade. */
  C.quiz = function (root, c) {
    var qs = c.questions || [], outcomes = c.outcomes || {};
    if (!qs.length) return;
    var box = el('div', 'lf-fc lf-fc--quiz');
    box.appendChild(el('p', 'lf-fc__kicker', c.kicker || 'find out'));
    var stage = el('div', 'lf-fc__stage'); box.appendChild(stage);
    var msg = live(box);
    var at = 0, tally = {};
    function ask() {
      stage.innerHTML = '';
      var q = qs[at];
      stage.appendChild(el('p', 'lf-fc__count', (c.counter || 'question {n} of {total}').replace('{n}', at + 1).replace('{total}', qs.length)));
      stage.appendChild(el('h3', 'lf-fc__q', q.q));
      var col = el('div', 'lf-fc__col');
      q.options.forEach(function (o) {
        var b = el('button', 'lf-fc__btn lf-fc__btn--choice lf-fc__btn--wide', o.label); b.type = 'button';
        b.addEventListener('click', function () {
          (o.scores || [o.outcome]).filter(Boolean).forEach(function (k) { tally[k] = (tally[k] || 0) + 1; });
          at++; if (at < qs.length) { ask(); stage.querySelector('button').focus(); } else done();
        });
        col.appendChild(b);
      });
      stage.appendChild(col);
    }
    function done() {
      var best = Object.keys(tally).sort(function (a, b) { return tally[b] - tally[a]; })[0];
      var o = outcomes[best] || {};
      stage.innerHTML = '';
      var res = el('div', 'lf-fc__reveal is-in');
      res.appendChild(el('p', 'lf-fc__kicker', c.resultKicker || 'most likely'));
      res.appendChild(el('p', 'lf-fc__big', o.title || best));
      if (o.body) res.appendChild(el('p', 'lf-fc__body', o.body));
      if (o.href && o.link) { var a = el('a', 'lf-fc__link', o.link); a.href = o.href; res.appendChild(a); }
      var again = el('button', 'lf-fc__skip', c.again || 'start over'); again.type = 'button';
      again.addEventListener('click', function () { at = 0; tally = {}; ask(); });
      res.appendChild(again);
      stage.appendChild(res);
      msg.textContent = res.textContent;
    }
    ask();
    root.appendChild(box);
  };

  /* ── 8 · What you haven't read yet ──────────────────────────────────────────
     The honest version of "library progress" (Dana, 22 Sep): a list of what is left,
     never a count, never a streak, never a reset. Reading a File marks it read; this only
     re-orders and labels links that are already on the page, so with the script off it is
     an ordinary list of articles. Per browser, and it not persisting costs nothing. */
  function markRead() {
    if (!/\/blogs\/[^/]+\/[^/]+/.test(location.pathname)) return;
    try {
      var seen = JSON.parse(store.get('read') || '[]');
      if (seen.indexOf(location.pathname) === -1) { seen.push(location.pathname); store.set('read', JSON.stringify(seen.slice(-200))); }
    } catch (e) {}
  }
  C.unread = function (root, c) {
    var seen = [];
    try { seen = JSON.parse(store.get('read') || '[]'); } catch (e) {}
    var links = Array.prototype.slice.call(root.querySelectorAll('a[href*="/blogs/"]'));
    if (!links.length) return;
    var fresh = links.filter(function (a) { return seen.indexOf(new URL(a.href, location.origin).pathname) === -1; });
    if (!fresh.length) {                                    /* read everything: say so once, quietly */
      if (c.allRead) root.insertBefore(el('p', 'lf-fc__body', c.allRead), root.firstChild);
      return;
    }
    /* unread first, in the order they were already in. No numbers, no percentage. */
    var parent = fresh[0].closest('li, article, div') === root ? null : fresh[0].parentNode;
    fresh.forEach(function (a) {
      var item = a.closest('li, article') || a;
      if (item.parentNode) item.parentNode.insertBefore(item, item.parentNode.firstChild);
      a.classList.add('lf-fc-unread');
    });
    if (c.label) {
      var note = el('p', 'lf-fc__kicker lf-fc__unreadnote', c.label);
      root.insertBefore(note, root.firstChild);
    }
  };

  /* ── boot ───────────────────────────────────────────────────────────────────── */
  function build(root) {
    if (root.__lffc) return; root.__lffc = true;
    var name = root.getAttribute('data-lf-component');
    var fn = C[name]; if (!fn) return;
    try { fn(root, cfg(root)); root.classList.add('lf-fc-ready'); }
    catch (e) { root.classList.remove('lf-fc-ready'); }   /* a broken component leaves the article intact */
  }
  function scan() { markRead(); document.querySelectorAll('[data-lf-component]').forEach(build); }
  window.__lfFC = { scan: scan, components: C };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
})();